exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".LagoUploadedImages_lago_upload_images_modal_container{display:flex;flex-wrap:wrap}.LagoUploadedImages_lago_upload_image_item{width:100px;height:100px;margin:15px;cursor:pointer}\n", ""]);

// Exports
exports.locals = {
	"lago_upload_images_modal_container": "LagoUploadedImages_lago_upload_images_modal_container",
	"lago_upload_image_item": "LagoUploadedImages_lago_upload_image_item"
};